import {
  Box,
  Button,
  Chip,
  Divider,
  FormControlLabel,
  Grid2,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as ScoreIcon } from "Assets/Icons/Classroom/ScoreIcon.svg";
import { ReactComponent as ObjectiveIcon } from "Assets/Icons/Classroom/ObjectiveIcon.svg";
import { ReactComponent as CodeIcon } from "Assets/Icons/Classroom/CodeIcon.svg";
import { ReactComponent as SQLEditorIcon } from "Assets/Icons/Classroom/SQLEditor.svg";
import { ReactComponent as AlertIcon } from "Assets/Icons/Leaderboard/AlertIcon.svg";
import { ReactComponent as ClockIcon } from "Assets/Icons/Home/ClockIcon.svg";
import { ReactComponent as SuccessIcon } from "Assets/Icons/Settings/SuccessIcon.svg";
import { ReactComponent as DiscussionIcon } from "Assets/Icons/Classroom/DiscussionIcon.svg";
import { ReactComponent as HintIcon } from "Assets/Icons/Classroom/HintIcon.svg";
import { ReactComponent as SolutionIcon } from "Assets/Icons/Classroom/SolutionIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import CompleteSolution from "Components/Classroom/ClassDialogs/CompleteSolution";
import CompleteSolutionConfirmation from "Components/Classroom/ClassDialogs/CompleteSolutionConfirmation";
import Hint from "./Hint";
import Discussions from "./Discussions";
import Warning from "Components/Common/Warning";
import { useDispatch, useSelector } from "react-redux";
import { submitAssignmentAnswer, submitAdditionalProblem } from "Slices/thunks";
import { useParams } from "react-router-dom";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  "& .blue": {
    background: theme.palette.border.blue,
  },
  "& .green": {
    background: theme.palette.success.light,
  },
  "& .pink": {
    background: theme.palette.error.light,
  }
});

const QuestionDetail = ({ question = {}, totalQuestions, selectedQue = 0, setSelectedQue, isScore = false }) => {
  const { tab } = useParams();
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState("");
  const [hintSuggestion, setHintSuggestion] = useState("");
  const [completeSolution, setCompleteSolution] = useState(false);
  const [unlockSolutionConfirmation, setUnlockSolutionConfirmation] = useState(false);

  let isHintOpen = hintSuggestion == "hint";
  let isDisussionOpen = hintSuggestion == "discussion";

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Course || {},
  }));

  const handleSubmit = (isViewHint = false, isViewSolution = false) => {
    if (isViewHint) {
      setHintSuggestion("hint");
    }

    const isViewedHint = isViewHint || question.IsViewHint ? true : false
    const isViewedSolution = isViewSolution || question.IsViewSolution ? true : false
    const notAttempt = isViewHint || isViewSolution ? true : false;

    if (!isViewedHint || !isViewedSolution) {

      console.log('question: ', question);
      const answerObj = {
        CourseID: question.CourseID,
        BatchID: question.BatchID,
        AssignmentID: question.AssignmentID,
        ProblemID: question.ProblemID,
        SessionID: question.SessionID,
        QuestionID: question.ID,
        OptionID: (isViewHint || isViewSolution) ? null : selectedOption,
        IsViewHint: isViewHint ? isViewHint : question.IsViewHint || false,
        IsViewSolution: isViewSolution ? isViewSolution : question.IsViewSolution || false,
        Attempt: notAttempt ? question.CurrentAttempt || 0 : question.CurrentAttempt ? question.CurrentAttempt + 1 : 1
      }

      tab === "problems" ?
      dispatch(submitAdditionalProblem(answerObj)) :
      dispatch(submitAssignmentAnswer(answerObj));
    }
  }

  useEffect(() => {
    setSelectedOption(question?.SelectedOptionID || "")
  }, [question?.SelectedOptionID])

  useEffect(() => {
    setHintSuggestion("");
  }, [selectedQue])

  return (
    <>
      <Grid2 sx={styles}>
        { isScore &&
          <Box
            display={"flex"}
            alignItems={"center"}
            gap={"10px"}
            justifyContent={"end"}
          >
            <Typography
              color="secondary.light"
              display={"flex"}
              alignItems={"center"}
              gap="5px"
            >
              <PrimaryIcon icon={ScoreIcon} width="18px" height="18px" />
              {Translation?.CurrentPossibleScore} {question.PossibleScore || 0}
            </Typography>
            <Divider flexItem orientation="vertical" />
            <Typography
              color="secondary.light"
              display={"flex"}
              alignItems={"center"}
              gap="5px"
            >
              <PrimaryIcon icon={ScoreIcon} width="18px" height="18px" />
              {Translation?.YourScore} {question.YourScore || 0}
            </Typography>
            <Divider flexItem orientation="vertical" />
            <Typography color="secondary.light">{Translation?.MaxScore} {question.MaxScore}</Typography>
          </Box>
        }
        <Box>
          <Box display={"flex"} alignItems={"center"} gap="10px">
            <Typography variant="title" fontWeight={500}>
              {/* Q1. Frame work for weight loss */}
              {question?.QuestionTitle}
            </Typography>
            <PrimaryIcon
              width="18px"
              height="18px"
              fill={false}
              icon={question?.QuestionTypeID === 5 ? SQLEditorIcon : question?.QuestionTypeID === 6 ? CodeIcon : ObjectiveIcon}
            />
            <Chip
              variant="outlined"
              outlined
              color={question.IsSelectedOptionCorrect ? 'success' : question.CurrentAttempt > 0 ? 'warning' : 'error'}
              label={
                <Box display={"flex"} alignItems={"center"} gap="5px">
                  <PrimaryIcon
                    width="14px"
                    height="14px"
                    icon={question.IsSelectedOptionCorrect ? SuccessIcon : question.CurrentAttempt > 0 ? ClockIcon : AlertIcon}
                    color={question.IsSelectedOptionCorrect ? 'success' : question.CurrentAttempt > 0 ? 'warning' : 'error'}
                  />
                  {question.IsSelectedOptionCorrect ? Translation?.Solved : question.CurrentAttempt > 0 ? Translation?.Attempted : Translation?.Unsolved}
                </Box>
              }
            />
          </Box>
          <Typography color="secondary.light" mt="5px"  dangerouslySetInnerHTML={{ __html: question?.QuestionDescription }}>
            {/* A group of people have volunteered to try out a diet for weight loss
            for 3 months. How should the null and alternate hypotheses be set
            up? */}
            {/* {selectedQue.QuestionDescriptionEn} */}
          </Typography>
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="subtitle" fontWeight={500}>
              {Translation?.ChooseCorrectAnswer}
            </Typography>
            <Chip
              label={
                <Typography fontWeight={500}> {(question.TotalAttempt - (question.CurrentAttempt || 0) || 0)} {Translation?.AttemptsLeft} </Typography>
              }
              color="warning"
            />
          </Box>
          <Box>
            <RadioGroup
              // value={notifications?.email}
              // onChange={(e) =>
              //   setNotifications((pre) => ({ ...pre, email: e.target.value }))
              // }
              value={selectedOption}
              name={`question`}
              className="radioGroup"
            >

              {question?.Options?.map((opt, i) => {
                const isSelected = selectedOption == opt.ID && !question?.IsSelectedOptionCorrect;
                const isCorrect = question.SelectedOptionID == opt.ID && question?.IsSelectedOptionCorrect;
                const isCorrectAnswer = selectedOption == opt.ID && question?.IsSelectedOptionCorrect;
                const isIncorrect = selectedOption == opt.ID && question.SelectedOptionID == opt.ID && question?.IsSelectedOptionCorrect === false;

                const className = isIncorrect ? 'pink' : isCorrect ? 'green' : isCorrectAnswer ? 'blue' : isSelected ? 'blue' : '';

                return (
                  <FormControlLabel key={i}
                    className={className}
                    value={opt.ID}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    control={<Radio size="small" 
                    disabled={question?.CurrentAttempt >= question?.TotalAttempt || question?.IsSelectedOptionCorrect} 

                    />}
                    label={
                      <Typography>
                        {" "}
                        {/* Important notifications about you or activity you've missed */}
                        {opt.Option}
                      </Typography>
                    }
                  />
                )
              })}

              {/* <FormControlLabel
                value="all"
                control={<Radio size="small" />}
                label={<Typography> All notifications </Typography>}
              />
              <FormControlLabel
                value="imp"
                control={<Radio size="small" />}
                label={
                  <Typography>
                    {" "}
                    Important notifications about you or activity you've missed
                  </Typography>
                }
              />
              <FormControlLabel
                value="only"
                control={<Radio size="small" />}
                label={
                  <Typography>
                    {" "}
                    Only notifications about your account, security, and privacy
                  </Typography>
                }
              />
              <FormControlLabel
                value="only"
                control={<Radio size="small" />}
                label={
                  <Typography>
                    {" "}
                    Only notifications about your account, security, and privacy
                  </Typography>
                }
              /> */}
            </RadioGroup>
          </Box>
          <Typography color="secondary.light" variant="body2">
            {Translation?.FeelFreeSubmitAnswer.replace("XXX", (question.TotalAttempt - (question.CurrentAttempt || 0) || 0))}
          </Typography>
          <Box display={"flex"} justifyContent={"space-between"}>
            <Box>
              { (question?.CurrentAttempt < question?.TotalAttempt && !question?.IsSelectedOptionCorrect) &&
                <Button variant="contained" onClick={() => handleSubmit(false)}>{Translation?.Submit}</Button>
              }
            </Box>
            
            <Box>
              { totalQuestions > selectedQue ?
                <Button variant="outlined" color="secondary" onClick={() => setSelectedQue((prev) => prev + 1)}>
                  {Translation?.Next}
                </Button> : <></>
              }
            </Box>
          </Box>

          <Box display={"flex"} gap="16px">
            {(question?.CurrentAttempt < question?.TotalAttempt && !question?.IsSelectedOptionCorrect) && 
              <Button
                startIcon={
                  <PrimaryIcon
                    color={isHintOpen ? "white" : "secondary"}
                    icon={HintIcon}
                    fill={false}
                    height="18px"
                    width="18px"
                  />
                }
                onClick={() => handleSubmit(true, false)}
                variant={isHintOpen ? "contained" : "outlined"}
                color={isHintOpen ? "primary" : "secondary"}
              >
                {Translation?.Hint}
              </Button>
            }
            {/* <Button
              startIcon={
                <PrimaryIcon
                  color={isDisussionOpen ? "white" : "secondary"}
                  icon={DiscussionIcon}
                  height="18px"
                  width="18px"
                />
              }
              variant={isDisussionOpen ? "contained" : "outlined"}
              color={isDisussionOpen ? "primary" : "secondary"}
              onClick={() => setHintSuggestion("discussion")}
            >
              Discussions
            </Button> */}
          </Box>
          {hintSuggestion && (isHintOpen ? <Hint question={question} handleSubmit={handleSubmit} /> : <Discussions />)}

          {(question?.CurrentAttempt < question?.TotalAttempt && !question?.IsSelectedOptionCorrect) && <>
              <Warning showAlert={false}>
                <Box display={"flex"} alignItems={"center"} gap="10px">
                  <PrimaryIcon icon={SolutionIcon} />
                  <Typography fontWeight={500} variant="title">
                    {Translation?.CompleteSolution}
                  </Typography>
                </Box>
                <Box
                  sx={{ marginLeft: "auto" }}
                  display={"flex"}
                  alignItems={"center"}
                  gap={"10px"}
                > { question.IsViewSolution ? 
                    <Button
                      onClick={() => setCompleteSolution(true)}
                      color="white"
                      variant="contained"
                    >
                      {Translation?.View}
                    </Button>
                  : <>
                    <Typography>{Translation?.PointsReduction}</Typography>
                    <Button
                      onClick={() => setUnlockSolutionConfirmation(true)}
                      color="white"
                      variant="contained"
                    >
                      {Translation?.Unlock}
                    </Button>
                  </>
                }
                </Box>
              </Warning>
              <Typography variant="body2" color="secondary.light">
                {Translation?.NoteUnlockCompleteSolution}
              </Typography>
            </>
          }

          
        </Box>
      </Grid2>

      <CompleteSolutionConfirmation
        open={unlockSolutionConfirmation}
        setOpen={setUnlockSolutionConfirmation}
        handleUnlock={() => {
          setUnlockSolutionConfirmation(false);
          setCompleteSolution(true);
          handleSubmit(false, true);
        }}
      />
      <CompleteSolution open={completeSolution} setOpen={setCompleteSolution} question={question} />
    </>
  );
};

export default QuestionDetail;
